export type SupportedLocale = 'ru' | 'en' | 'es' | 'fr' | 'ar' | 'zh-CN' | 'zh-HK';
export type LocaleDirection = 'ltr' | 'rtl';

export const DEFAULT_LOCALE: SupportedLocale = 'ru';
export const LOCALE_STORAGE_KEY = 'chattenger:web:locale';
export const LOCALE_COOKIE_KEY = 'chattenger_web_locale';

export const SUPPORTED_LOCALES: SupportedLocale[] = ['ru', 'en', 'es', 'fr', 'ar', 'zh-CN', 'zh-HK'];

export const normalizeLocale = (value: string | null | undefined): SupportedLocale => {
    if (value === 'ru' || value === 'en' || value === 'es' || value === 'fr' || value === 'ar' || value === 'zh-CN' || value === 'zh-HK') {
        return value;
    }

    return DEFAULT_LOCALE;
};

export const getLocaleDirection = (locale: SupportedLocale): LocaleDirection => (locale === 'ar' ? 'rtl' : 'ltr');

export const getIntlLocale = (locale: SupportedLocale) => {
    if (locale === 'zh-CN' || locale === 'zh-HK') {
        return locale;
    }

    return locale;
};
